module.exports = __webpack_public_path__ + "static/ena250-95aca7086a01751e099bf8c23d9ebd4c.png";